function convertObjectToUrlParams(obj) {
  const urlParams = Object.keys(obj).map((key) => `${key}=${obj[key]}`).join('&');

  return `?${urlParams}`;
}

export default convertObjectToUrlParams;
